import React, { memo } from 'react'
import parse from 'autosuggest-highlight/parse'
import { match } from 'utils/autocomplete/match'

interface IHighlightedMarkupProps {
  suggestion: string | undefined
  value: string | undefined
}

/**
 * Highlight the matched part of the suggestion
 * @see https://github.com/moroshko/autosuggest-highlight/
 */
export const HighlightedMarkup = memo<IHighlightedMarkupProps>(
  ({ suggestion = '', value = '' }) => {
    const matches = match(suggestion, value, {
      /**
       * Finds all occurrences of each match
       * @example '2' will match 'R[2]D2'
       */
      findAllOccurrences: false,
      /**
       * Requires each word of query to be found in text or else returns an empty set
       * @example 'darth' will match '[Darth] Vader'
       */
      requireMatchAll: false,
      /**
       * Searches inside words
       * @example 'or' will match 'hello w[or]ld'
       */
      insideWords: true,
    })
    const parts = parse(suggestion, matches)
    return (
      <span data-test='highlighted-markup'>
        {parts.map((part, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <span className={part.highlight ? 'b' : ''} key={`${i}-${part.text}`}>
            {part.text}
          </span>
        ))}
      </span>
    )
  }
)
